import { useEffect, useRef } from 'react';

export const usePrevious = (value) => {
  const ref = useRef();
  useEffect(() => {
    ref.current = value;
  });
  return ref.current;
};

export const useEffectAsync = (effect, deps) => {
  const ref = useRef();
  let abortController;

  useEffect(() => {
    effect().then((result) => (ref.current = result));
    // eslint-disable-next-line react-hooks/exhaustive-deps
    abortController = new AbortController();

    return () => {
      const result = ref.current;
      if (result) {
        result();
      }
      abortController.abort();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);
};
